// Module
var code = `<table class="table table-hover">
	<thead>
		<tr>
			<th class="col-md-10">Task name</th>
			<th class="col-md-2">Action</th>
		</tr>
	</thead>
	<tbody>
		<tr ng-repeat="task in tasks">
			<td>{{task.title}}</td>
			<td><button class="btn btn-primary" ng-click="run_task(task.cmd)">Run task</button></td>
		</tr>
	</tbody>
</table>
`;
// Exports
module.exports = code;